import {
  Button,
  Checkbox,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
} from '@design-system';

import { Loader2, User } from 'lucide-react';

import { useSelfTestIntakeForm } from '@/features/invite-client';
import { usePilotSelfPlanIntakeForm } from '@/shared/hooks/use-active-pilot-program';

export function SelfTestIntakeFormTab() {
  const { form, onSubmit, isLoading } = useSelfTestIntakeForm();
  const selfPlanIntakeForm = usePilotSelfPlanIntakeForm();

  if (!selfPlanIntakeForm) {
    return null;
  }

  return (
    <div className="space-y-6">
      <div>
        <h4 className="text-base font-semibold text-gray-950">Plan for Yourself</h4>
        <p className="text-foreground text-sm">
          Use Waterlily to create a plan for your own long-term care needs. Your name is pre-filled
          from your account.
        </p>
      </div>

      <Form {...form}>
        <form
          onSubmit={onSubmit}
          className="space-y-6"
        >
          <div className="space-y-6">
            <FormField
              control={form.control}
              name="firstName"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>First name</FormLabel>
                  <FormControl>
                    <Input
                      disabled
                      className="bg-muted"
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="lastName"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Last name</FormLabel>
                  <FormControl>
                    <Input
                      disabled
                      className="bg-muted"
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name="acknowledgement"
              render={({ field }) => (
                <FormItem>
                  <div className="flex items-start gap-3">
                    <FormControl>
                      <Checkbox
                        id="pilot-self-plan-acknowledgement"
                        checked={field.value === true}
                        onCheckedChange={checked => field.onChange(checked === true)}
                        className="mt-0.5"
                      />
                    </FormControl>
                    <label
                      htmlFor="pilot-self-plan-acknowledgement"
                      className="text-foreground cursor-pointer text-sm"
                    >
                      {selfPlanIntakeForm.acknowledgementText}
                    </label>
                  </div>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>

          <Button
            type="submit"
            className="w-full"
            disabled={!form.formState.isValid || isLoading}
          >
            {isLoading ? (
              <>
                <Loader2 className="size-4 animate-spin" />
                Creating...
              </>
            ) : (
              <>
                <User className="size-4" />
                Continue
              </>
            )}
          </Button>
        </form>
      </Form>
    </div>
  );
}
